import React from "react";
import "./Loader.css";
import logo from "../../../images/logo.png";

const Loader = (props) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center bg-white`}
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        opacity: props.forProcess ? 0.8 : 1,
        zIndex: 10,
      }}
    >
      <div className="h-45 w-45 fade-in-out">
        <img src={logo} alt="" style={{ width: "80px", height: "80px" }} />
      </div>
    </div>
  );
};

export default Loader;
